// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__11CsR","title":"styles_title__3FOli","text":"styles_text__1Vua7","textFlex":"styles_textFlex__2Iln8"};